export default "__VITE_ASSET__acc905f2__"